import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ical-feed-icon-34x14.png")